import TestimonialsCarousel from "./components/TestimonialsCarousel";
customElements.define("testimonials-carousel", TestimonialsCarousel);

import ServicesCarousel from "./components/ServicesCarousel";
customElements.define("services-carousel", ServicesCarousel);

import GarantiesCarousel from "./components/GarantiesCarousel";
customElements.define("garanties-carousel", GarantiesCarousel);

import PrivateCarousel from "./components/PrivateCarousel";
customElements.define("private-carousel", PrivateCarousel);

import OffersCarousel from "./components/OffersCarousel";
customElements.define("offers-carousel", OffersCarousel);

import LastCarousel from "./components/LastCarousel";
customElements.define("last-carousel", LastCarousel);

import LocCarousel from "./components/LocCarousel";
customElements.define("loc-carousel", LocCarousel);